export const SET_ACTIVE_LOUNGE = 'SET_ACTIVE_LOUNGE';
export const SET_ACTIVE_BOOTH_SPACE = 'SET_ACTIVE_BOOTH_SPACE';

export function setActiveLounge(lounge) {
    return {
        type: SET_ACTIVE_LOUNGE,
        payload: {
            activeLounge: lounge,
        },
    };
}
export function setActiveBoothSpace(boothSpace) {
    return {
        type: SET_ACTIVE_BOOTH_SPACE,
        payload: {
            activeBoothSpace: boothSpace,
        },
    };
}
